import type { CSSProperties } from "react";

export interface ReviewItem {
  name: string;
  quote: string;
  role: string;
  stars: number;
  image?: string;
}

function initials(name: string) {
  return name.split(/\s+/).filter(Boolean).slice(0, 2).map((part) => part[0]).join("").toUpperCase();
}

function ReviewCard({ item, index }: { item: ReviewItem; index: number }) {
  const hue = [24, 37, 14, 42, 19, 32][index % 6];
  return (
    <article className="review-marquee-card" style={{ "--avatar-hue": hue } as CSSProperties}>
      <div className="review-marquee-stars" role="img" aria-label={`${item.stars} fictional stars`}>
        <span aria-hidden="true">{Array.from({ length: 5 }, (_, star) => <svg key={star} viewBox="0 0 24 24" className={star < item.stars ? "is-rated" : ""}><path d="m12 2.8 2.8 5.7 6.3.9-4.55 4.43 1.08 6.27L12 17.14l-5.63 2.96 1.08-6.27L2.9 9.4l6.3-.91L12 2.8z" /></svg>)}</span>
      </div>
      <blockquote>&ldquo;{item.quote}&rdquo;</blockquote>
      <div className="review-marquee-byline">
        {item.image ? <img className={item.name === "Lakon Spaceways" ? "review-manufacturer-mark" : "review-portrait"} src={item.image} alt="" loading="lazy" /> : <span className="review-initials" aria-hidden="true">{initials(item.name)}</span>}
        <span><strong>{item.name}</strong><small>{item.role}</small></span>
      </div>
    </article>
  );
}

function Rail({ items, direction }: { items: ReviewItem[]; direction: "left" | "right" }) {
  return (
    <div className={`review-marquee-window move-${direction}`}>
      <div className="review-marquee-track">
        {items.map((item, index) => <ReviewCard key={`${direction}-${index}`} item={item} index={index} />)}
        <div className="review-marquee-copy" aria-hidden="true">
          {items.map((item, index) => <ReviewCard key={`copy-${direction}-${index}`} item={item} index={index} />)}
        </div>
      </div>
    </div>
  );
}

export function ReviewsMarquee({ items }: { items: ReviewItem[] }) {
  const middle = Math.ceil(items.length / 2);
  return <div className="reviews-marquee">
    <div className="reviews-marquee-desktop" aria-label="Fictional pilot and manufacturer reviews">
      <Rail items={items.slice(0, middle)} direction="left" />
      <Rail items={items.slice(middle)} direction="right" />
    </div>
    <div className="reviews-mobile-scroll" role="region" aria-label="Four fictional reviews. Scroll horizontally to see all four." tabIndex={0}>
      {items.slice(0, 4).map((item, index) => <ReviewCard key={`mobile-${index}`} item={item} index={index} />)}
    </div>
  </div>;
}
